import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import ContentsTab   from 'contents_tab';
import CastingCommon from '@utils/casting-common';

import ProjectHeader               from '@project/contents/project-header';

import Summary                     from '@project/contents/summary/_summary';
import Workflow                    from '@project/contents/workflow/_workflow';
import Tasks                       from '@project/contents/tasks/_tasks';
import Calender                    from '@project/contents/calender/_calender';
import CastingList                 from '@project/contents/casting_list/_casting_list';
import Report                      from '@project/contents/report/_report';

import ProjectInfluencer           from '@project/parts/side-influencer/_side-influencer';
import ProjectInsightLogin         from '@project/parts/insight-login/_insight-login';

import ProjectAssignSettingModal   from '@project/modal/assign-setting-modal/_assign-setting-modal';
import ProjectDraftListModal       from '@project/modal/draft-list-modal/_draft-list-modal';
import ProjectDraftSettingModal    from '@project/modal/draft-setting-modal/_draft-setting-modal';
import ProjectReportCandidateModal from '@project/modal/report-select-modal/_report-select-modal';
import ProjectPostContentsModal    from '@project/modal/post-contents-modal/_post-contents-modal';
import ProjectSendFirstDmModal     from '@project/modal/send-first-dm-modal/_send-first-dm-modal';
import ProjectMemoCreateModal      from '@project/modal/memo-create-modal/_memo-create-modal';
import ProjectClientCheckModal     from '@project/modal/client-check-modal/_client-check-modal';
import ProjectCandidateModal       from '@project/modal/select-candidate-modal/_select-candidate-modal';
// -------------------------------------------------------

class Project extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    let tab = Utils.getLocalData({ id: 'project/tab', default: 'summary' });
    
    try {
      let options = this.props.data.options;
      if( options.mode == 'edit-report' ) tab = 'report';
    } catch(e) {}
    
    this.state = {
      tab : tab,
    };
  }
  // -------------------------------------------------------
  
  componentDidMount() {
    try {
      let options = this.props.data.options;
      if( options.mode == 'report-view' ){
        this.props.data.event.showReportCandidateModal.bind(this)(this.props.data.project.id, options.insta_user_id, options.contents_id);
      }
      if( options.mode == 'edit-report' ){
        this.props.data.event.editReportModal.bind(this)(options.contents_id);
      }
      
    } catch(e) {}
  }
  // -------------------------------------------------------
  
  /*
   * ナビの変更
   */
  changeNavigation(tab) {
    this.setState({ tab: tab });
    Utils.saveLocalData({ id: 'project/tab', data: tab });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    // 通知件数の取得
    let pop_count = 0;
    for( let insta_user_id in data.workflow.influencers ){
      if( CastingCommon.getRequestAction(data, insta_user_id) != null ) pop_count += 1;
    }
    
    let tabs = [
      { id: 'summary',      name: 'サマリー',             html: <Summary data={data} /> },
      { id: 'workflow',     name: 'ワークフロー',         html: <Workflow data={data} /> },
      { id: 'task',         name: 'タスク',               html: <Tasks data={data} alert_count={pop_count} />, pop_count: pop_count },
      { id: 'casting_list', name: 'キャスティングリスト', html: <CastingList data={data} /> },
      { id: 'calender',     name: '投稿リマインド・予定', html: <Calender data={data} /> },
      { id: 'report',       name: 'レポート',             html: <Report data={data} /> },
    ];
    
    return (
      <div id="project">
        3ab
        <ProjectHeader data={data} />
        <ProjectInfluencer data={data} />
        <ProjectInsightLogin data={data} />
        <ProjectAssignSettingModal data={data} />
        <ProjectDraftListModal data={data} />
        <ProjectDraftSettingModal data={data} />
        <ProjectReportCandidateModal data={data} />
        <ProjectPostContentsModal data={data} />
        <ProjectSendFirstDmModal data={data} />
        <ProjectMemoCreateModal data={data} />
        <ProjectClientCheckModal data={data} />
        <ProjectCandidateModal data={data} />
        
        <div className="project-container">
          <ContentsTab tabs={tabs} select={this.state.tab} font_size={16} change_ev={this.changeNavigation.bind(this)} />
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Project;